import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type EditGroupFailureModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function EditGroupFailureModal({ isOpen, handleClose }: EditGroupFailureModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="edit-group-failure">
      <AcknowledgeModal
        result="negative"
        title={t('typography.somethingWentWrong')}
        description={t('errorMessage.genericError')}
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
